import {Component, OnInit} from '@angular/core';
import {TakeUntilDestroy} from '../../services/take-until-destroy.decorator';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import {Observable} from 'rxjs';
import {LogsService, EeHttpLogPagination} from '../../swagger-codegen';
import {ColumnSortedEvent, SortService} from '../../sortable-column/sort-service';
import {finalize, takeUntil} from 'rxjs/operators';

@TakeUntilDestroy
@Component({
  selector: 'app-http-log',
  templateUrl: './http-log.component.html',
  styleUrls: ['./http-log.component.scss']
})
export class HttpLogComponent implements OnInit {

  @BlockUI()
  blockUI: NgBlockUI;
  componentDestroy: () => Observable<boolean>;
  public currentLogs: EeHttpLogPagination;
  sortEvent: ColumnSortedEvent;
  pageSize = 10;
  previousPage = 1;
  currentPage = 1;
  totalPages = 0;
  userId;
  responseStatusCode;

  constructor(private ls: LogsService, private sortService: SortService) {
  }

  ngOnInit(): void {
    this.sortEvent = {sortColumn: 'Id', sortDirection: 'desc'};
    this.sortByEvent();
  }

  public onSorted(event: ColumnSortedEvent): void {
    this.sortEvent = event;
    this.sortByEvent();
  }

  sortByEvent(currentPage: number = 1): void {
    if (this.sortEvent) {
      this.blockUI.start();
      this.ls.apiAdminLogsHttpLogsAllGet(this.sortEvent.sortColumn,
        this.sortEvent.sortDirection === 'desc', currentPage, this.pageSize, (this.userId ? this.userId : 0),
        (this.responseStatusCode ? this.responseStatusCode : 0)).pipe(
        finalize(this.blockUI.stop),
        takeUntil(this.componentDestroy()))
        .subscribe((result) => {
          this.currentLogs = result;
          this.currentPage = result.currentPage;
          this.pageSize = result.pageSize;
          this.totalPages = result.totalPages;
          this.sortService.lastSortEvent = this.sortEvent;
        });

    } else if (
      !this.sortEvent &&
      this.sortService.lastSortEvent
    ) {
      this.sortEvent = this.sortService.lastSortEvent;
      this.sortByEvent();
    }
  }

  pageChanged(newPage: number): void {
    if (newPage !== this.previousPage) {
      this.previousPage = newPage;
      this.sortByEvent(newPage);
    }
  }

  searchByButton(): void {
    this.sortEvent = {sortColumn: 'Id', sortDirection: 'desc'};
    this.sortByEvent();
  }
}
